import { FunctionalityInDataGrid } from 'src/app/components/functionalities-data-grid/functionality-in-data-grid.type';

export type UsersList = UsersManagementDTO[];

export type ListUsersRouteData = {
  users: UsersList;
};

export class UsersManagementDTO {
  id: string;
  name: string;
  surname: string;
  mail: string;
  roleName: string;
  roleId: string;
  isAdmin: boolean;
  isSuperUser: boolean;
  state: number;
  dateCreation: Date;
  note: string;
  password: string;
  repeatPassword: string;
  listAziende: number[];
  listPermission: FunctionalityInDataGrid[];

  constructor() {
    this.isAdmin = false;
    this.isSuperUser = false;
    this.state = 0;
    this.listAziende = [];
    this.listPermission = [];
    this.name = '';
    this.surname = '';
    this.mail = '';
  }
}
